import serverProps from '../utils/serverProps'
import { ActionTypes as types } from '../constants'

function getInitialState({ storyDetails = {} } = {}) {
  const {
    id: storyId,
    messages = [],
    isBlocked = false,
    participants = [],
    transactions = [],
    error = null,
  } = storyDetails

  const initialState = {
    storyId,
    messages,
    isBlocked,
    participants,
    transactions,
    blockAlert: null,
    error,
  }

  return initialState
}

export default (state = getInitialState(serverProps), action) => {
  const { data: { message, error, alertCode, debugId } = {} } = action
  switch (action.type) {
    case types.STORY.SEND_MESSAGE:
      return {
        ...state,
        messages: [...state.messages, message],
      }
    case types.STORY.REMOVE_MESSAGE:
      return {
        ...state,
        messages: state.messages.filter(msg => msg !== message),
      }
    case types.STORY.MESSAGE_ERROR:
      return {
        ...state,
        messages: state.messages.map(msg => {
          if (msg === message) {
            return {
              ...msg,
              error,
            }
          }
          return msg
        }),
      }
    case types.STORY.CHAT_UPDATED_CONTACT_BLOCK:
      return {
        ...state,
        isBlocked: true,
      }
    case types.STORY.RENDER_BLOCK_ALERT:
      return {
        ...state,
        blockAlert: { alertCode, debugId },
      }
    case types.STORY.DISMISS_BLOCK_ALERT:
      return {
        ...state,
        blockAlert: null,
      }
    default:
      return state
  }
}
